import React from 'react';
import { PopperPositions } from '@elliemae/ds-popper';
import DSTruncatedTooltipText from '@elliemae/ds-truncated-tooltip-text';

function MultiValueLabel(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    tooltipPlacement: PopperPositions.TOP,
    value: children
  });
}

export default MultiValueLabel;
//# sourceMappingURL=MultiValueLabel.js.map
